import Aos from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect } from "react";
import projectOne from "../../img/FinalEdit/ProjectNewOne.png";
const Projects = ({ project }) => {
  console.log(project);
  useEffect(()=>{

    Aos.init({duration:2000})
  },[])

  const {
    name,
    javascript,
    mongodb,
    reactjs,
    nodejs,
    express,
    html,
    css,
    bootstrap,
    material,
    illustrator,
    photoshop,
    xd,
    redux
  } = project;

  return (
    <div className="container px-10 mx-auto my-20">
      <div
        data-aos="zoom-in-left"
        className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12"
      >
        <div data-aos="flip-right">
          <img
            className="object-contain h-full w-full"
            src={projectOne}
            alt=""
          />
        </div>
        <div>
          <h1
            data-aos="flip-left"
            className="mt-6 pt-6 text-center mb-2 font-bold text-4xl md:text-5xl lg:text-6xl"
          >
            Projects
          </h1>
          <h3 className="pt-6 text-center mb-2 font-bold text-2xl md:text-2xl lg:text-2xl">
            I always like to learn about trending technologies and exploit those in my projects
          </h3>
        </div>
      </div>

      {/* project part */}

      <div >
        <div class="mt-8 grid md:grid-cols-3 lg:grid-cols-3 gap-x-3">



{/* BLog Site */}
<div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-purple-300 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
               Blog Site
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://blog-site-r.web.app/" rel="noreferrer">
                  Users can click the blog and read the full blog.Only the admin can update the blog and also can delete the blog.
                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2021-06-23</h1>
                  </div>
                  <div>
                  <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={javascript}
                        alt=""
                      />
                      
                      </div>

                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={reactjs}
                        alt=""
                      />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/blog-site" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://blog-site-r.web.app/" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>


















        {/* Aventador */}
        <div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-green-300 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
                Aventador 
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://aventador-s-l.web.app/" rel="noreferrer">
                  This is a Team Project.We created this site inspired by Tesla,We use Redux for state management.
                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2021-05-30</h1>
                  </div>
                  <div>
                  <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={javascript}
                        alt=""
                      />
                      
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={redux}
                        alt=""
                      />
                      
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={material}
                        alt=""
                      />
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/team-work" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://aventador-s-l.web.app/" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

















         
         
         {/* portfoli website */}
          <div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-blue-300 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
                  Portfolio Website Version 2.0
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://rian-portfolio.web.app/" rel="noreferrer">
                    The complete portfolio website hosted using Firebase,i want show what i do
                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2020-03-12</h1>
                  </div>
                  <div>
                  <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={javascript}
                        alt=""
                      />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/small-portfolio-website" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://rian-portfolio.web.app/" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>




{/* TechSoft project */}



          <div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-pink-300 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
                  TechSoftware
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://repair-items.web.app/" rel="noreferrer">
                    Repair Center website,User can take service and give feedback.
                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2021-04-15</h1>
                  </div>
                  <div>
                    <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={javascript}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={reactjs}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={nodejs}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={mongodb}
                        alt=""
                      />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/small-portfolio-website" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://repair-items.web.app/" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>


{/* Bikehub project */}



          <div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-indigo-300 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
                  BikeHub
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://bike-zone-franz.web.app" rel="noreferrer">
                  This is a bike showroom website.user can show details about the bike, order the bike and show their own order list.                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2021-03-31</h1>
                  </div>
                  <div>
                  <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={javascript}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={reactjs}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={nodejs}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={mongodb}
                        alt=""
                      />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/small-portfolio-website" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://bike-zone-franz.web.app" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>


{/* road king rider */}



          <div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-yellow-100 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
                  Road King Rider
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://react-auth-rianislam.web.app/" rel="noreferrer">
                  User can Choose their option and Use it to move
                  Simple react router web site.load data using fake api.                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2021-03-18</h1>
                  </div>
                  <div>
                  <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={javascript}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={reactjs}
                        alt=""
                      />
                      </div>
      
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/RodeKingRider" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://react-auth-rianislam.web.app/" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>




{/* Airbnb Clone */}


<div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-blue-300 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
                  Airbnb Clone
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://reactjs-airbnb-clone.web.app" rel="noreferrer">
                  cloning this I can understand some things in reactjs those are react-router and react props.
                  I enjoy this learning method.     
                                    
                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2021-01-06</h1>
                  </div>
                  <div>
                  <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={javascript}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={reactjs}
                        alt=""
                      />
                      </div>
                      
                      
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/reactjs_airbnb_clone" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://reactjs-airbnb-clone.web.app" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>



          


          {/* Simple html css javascript */}


<div data-aos="fade-up" className="mx-auto ">
            <div className="card bg-red-100 hover:shadow-lg">
              <div className="m-4">
                <h1 className="py-3 font-bold">
                Penguin Fashion
                </h1>
                <h1 className="py-1 block text-gray-500 text-sm">
                  <a target="_blank" href="https://rianislam.github.io/Responsive-Website/" rel="noreferrer">
                  Shoe showroom website using HTML and CSS,i also make it responsive with the help of BOOTSTRAP.     
                                    
                  </a>
                </h1>
                <div className="py-3 flex justify-between ">
                  <div>
                    <h1>Created on 2021-01-14</h1>
                  </div>
                  <div>
                  <div className=" flex justify-between">
                      <div className="">
                      <img
                        className="object-contain h-8 w-8 "
                        src={html}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={css}
                        alt=""
                      />
                      </div>
                      <div className="mx-1">
                      <img
                        className="object-contain h-8 w-8 "
                        src={bootstrap}
                        alt=""
                      />
                      </div>
                   
                      
                      
                    </div>
                  </div>
                </div>
                <div className="py-3 flex justify-between">
                  <div>
                    <a
                      target="_blank"
                      href="https://github.com/mdrianislam0or1/Responsive-Website" rel="noreferrer"
                    >
                      View Code
                    </a>
                  </div>
                  <div>
                    <a target="_blank" href="https://rianislam.github.io/Responsive-Website/" rel="noreferrer">
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>



          






          











          
        </div>
      </div>
      <div data-aos="fade-down" className="mt-10 text-center">
      <button className="animate-bounce  bg-gray-800  font-semibold text-white py-2 px-4 border border-gray-800 ">
          <a target="_blank" href="https://github.com/mdrianislam0or1" rel="noreferrer">
          More Project
          </a>
           
          </button>
      </div>
    </div>
  );
};

export default Projects;
